import * as log from 'loglevel'
export as namespace log
export = log
